/** A referential list of outcomes: no tenant, no parameter. */
class FetchAuditOutcomes {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchAuditOutcomes;
